import Sleepy from './sleepy.class';

const sm = new Sleepy();

class FAQ {
    constructor(el) {
        this.el = el
        this.toggler = el.querySelector('.toggle')
        this.heading = el.querySelector('.toggle + h3')

        this.toggler.addEventListener('click', () => this.toggle())
        this.heading.addEventListener('click', () => this.toggle())

        // opens the faq item if the 's' parameter (with dash separation between words) in the query string matches the title
        const val = sm.getQuerystring('s', null)
        const stripped = this.heading.innerText.replace(/[\.,-\/#!$%\^&\*;:{}=\-_`~()@\+\?><\[\]\+]/g, '');
        // console.log('This is a test.'.toLowerCase().replaceAll(' ', '-'))
        if (val !== '') {
            const lVal = val.toLowerCase()
            // console.log(lVal);
            if (lVal === stripped.toLowerCase().replaceAll(' ', '-')) {
                this.closeAll();
                this.open();
                
                setTimeout(() => {                    
                    let y = this.heading.getBoundingClientRect().top - 155;
                    console.log(y);
                    window.scrollTo({
                        top: y,
                        behavior: "smooth",
                    });
                }, 500);
            }
        } else {

        }
    }

    open() {
        this.el.classList.add('opened')
    }

    close() {
        this.el.classList.remove('opened')
    }

    toggle() {
        if (this.isOpened()) {
            this.close()
        } else {
            this.closeAll();
            this.open()
        }
    }

    closeAll() {
        const items = document.querySelectorAll('.paragraph--type--collapsible-item')
        items.forEach((item) => {
            item.classList.remove('opened')
        })
    }

    isOpened() {
        return this.el.classList.contains('opened')
    }
}

export default FAQ


// WEBPACK FOOTER //
// ./js/classes/faq.class.js